exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-25623ca1] {\n  margin: 10px 0;\n}\n.space-bottom[data-v-25623ca1] {\n  margin-bottom: 20px;\n}", ""]);

// exports
